import { Link } from "@inertiajs/react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

export interface CreatorAnalyticsNoOauthCardProps {
  /** `crewMessagePath(id)` — the existing brand-side conversation
   *  surface for this membership. */
  messagesPath: string
}

/**
 * OKS-64 — Empty-state card for `oauth_state === "none"`. Shown when
 * the creator has never connected TikTok (manual-only signup).
 *
 * Per UX Spec §3 + PRD §3: this state is informational + has a hint
 * ("Ask via Messages") that links to the existing brand-side
 * conversation. No auto-nudge to the creator (PRD OQ-9 lock).
 */
export function CreatorAnalyticsNoOauthCard({
  messagesPath,
}: CreatorAnalyticsNoOauthCardProps) {
  const { t } = useTranslation()

  return (
    <Card data-testid="creator-analytics-timeseries-no-oauth">
      <CardContent className="flex flex-col items-center gap-3 py-12 text-center">
        <h3 className="text-base font-medium">
          {t("crew.analytics.timeseries.no_oauth.title")}
        </h3>
        <p className="text-muted-foreground max-w-md text-sm">
          {t("crew.analytics.timeseries.no_oauth.body")}
        </p>
        <Button asChild variant="secondary">
          <Link
            href={messagesPath}
            data-testid="creator-analytics-no-oauth-ask"
          >
            {t("crew.analytics.timeseries.no_oauth.cta")}
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}

export default CreatorAnalyticsNoOauthCard
